var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Download50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M24 37.1L13 24 35 24zM20 4H28V8H20zM20 10H28V14H20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M20 16H28V27H20zM6 40H42V44H6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Download50);
export default __webpack_public_path__ + "static/media/icons8-download-50.842f7c5ec649f2cacf45b06f6177f66f.svg";
export { ForwardRef as ReactComponent };